import React, { useState } from "react";
import moment from "moment";
import ReturnVehicleType from "../Helper/ReturnVehicleType";
import CancelAppointmentModal from "../Structure/CancelAppointmentModal";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

function AppointmentsTable({ data, cancelCall }) {
  // 1) Data
  const [showModal, setshowModal] = useState(false);
  const [selectedData, setselectedData] = useState();
  const { t } = useTranslation();

  // 3)

  return (
    <>
      <div className="table-container ">
        {/*Desktop Table */}
        <table className="hideBigTable">
          <thead>
            <tr>
              <th>{t("Ημερομηνία")}</th>
              <th>{t("Destination")}</th>
              <th>{t("Απόσταση-Χρόνος")}</th>
              <th>{t("Customer")}</th>
              <th>{t("Vehicle")}</th>
              <th>{t("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <>
                <tr
                  key={item.info.reservationDate}
                  className="hover:bg-gray-300 "
                >
                  <td>
                    <div className="bg-gray-200 text-center rounded-md p-1">
                      {item.info.reservationDate.length > 0 ? (
                        <>
                          <p className="font-semibold">
                            {item.info.reservationDate.split("T")[1]}
                          </p>
                          <p> {item.info.reservationDate.split("T")[0]}</p>
                        </>
                      ) : (
                        <>-</>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="bg-gray-200 text-center rounded-md p-1 h-12 items-center flex justify-center">
                      {item.info.destination.length > 0 ? (
                        <>
                          {item.info.destination} <br />
                        </>
                      ) : (
                        <div className="text-gray-300">-</div>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="bg-gray-200 text-center rounded-md p-1 h-12 items-center flex justify-center">
                      {item.info.routeInfo != undefined ? (
                        <div className="flex-column">
                          <p>{item.info.routeInfo.distance + ""}</p>

                          <p>{item.info.routeInfo.time}</p>
                        </div>
                      ) : (
                        <div className="text-gray-300">-</div>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="bg-gray-200 text-center rounded-md h-12 flex justify-center items-center p-1">
                      {item.info.customerName == "" ? (
                        "-"
                      ) : (
                        <>{item.info.customerName}</>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="bg-gray-200 text-center rounded-md p-1  h-12 flex justify-center items-center">
                      {item.info.vehType == "" ? (
                        "-"
                      ) : (
                        <>
                          <ReturnVehicleType vt={item.info.vehType} />
                        </>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="bg-gray-200 text-center rounded-md flex h-12 justify-center items-center p-1">
                      <div className="flex items-center justify-center">
                        {moment(item.info.reservationDate).isBefore(
                          moment()
                        ) ? (
                          <>
                            {item.info.reservationStatus == 30 ||
                            item.info.reservationStatus == 31 ? (
                              <> {t("Ακυρώθηκε")}</>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <>
                            {item.info.reservationStatus == 30 ||
                            item.info.reservationStatus == 31 ? (
                              <> {t("Ακυρώθηκε")}</>
                            ) : (
                              <>
                                <div
                                  onClick={async () => {
                                    await setselectedData(item);
                                    setshowModal(true);
                                  }}
                                  className="text-base px-3 border border-red-500 rounded p-1 cursor-pointer hover:scale-105 flex items-center justify-center"
                                >
                                  <div className=" bg-red-500 text-white h-5 w-5 rounded-full flex justify-center items-center mr-2">
                                    <CloseIcon fontSize="small" />
                                  </div>

                                  <p className="font-semibold">
                                    {t("Ακύρωση")}
                                  </p>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
        {/* Mobile Phones Table */}
        <table className="showSmallTable">
          <tbody>
            {data.map((item) => (
              <>
                <tr
                  key={item.info.date}
                  className="rounded-md shadow shadow-gray-400"
                >
                  <div
                    className={
                      moment(item.info.reservationDate).isBefore(moment())
                        ? "bg-gray-500 Primary_Dark_Text text-end mt-3  rounded-t  p-1"
                        : "Primary_Main_Background Primary_Dark_Text text-end mt-3  rounded-t  p-1"
                    }
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="  text-base px-3 text-white font-semibold">
                          {item.info.reservationDate.split("T")[0] +
                            " " +
                            item.info.reservationDate.split("T")[1]}
                        </div>
                      </div>
                      {/* Check Date */}
                      {moment(item.info.reservationDate).isBefore(moment()) ? (
                        <></>
                      ) : item.info.reservationStatus == 30 ||
                        item.info.reservationStatus == 31 ? (
                        <p className="text-white font-semibold mr-2">
                          {t("Ακυρώθηκε")}
                        </p>
                      ) : (
                        <>
                          <div
                            onClick={async () => {
                              await setselectedData(item);

                              setshowModal(true);
                            }}
                            className="Primary_Light_Background rounded Primary_Dark_Text text-base px-3 cursor-pointer hover:scale-105 flex p-1 items-center"
                          >
                            <div className=" bg-red-500 text-white h-5 w-5 rounded-full flex justify-center items-center mr-2 ">
                              <CloseIcon fontSize="small" />
                            </div>
                            {t("Ακύρωση")}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {t("Destination") + " : "} {item.info.destination}
                  </div>
                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {item.info.routeInfo != undefined &&
                      t("Απόσταση-Χρόνος") +
                        " : " +
                        item.info.routeInfo.distance +
                        " & " +
                        item.info.routeInfo.time}
                  </div>

                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {t("Customer")} {" : "}
                    {item.info.customerName == "" ? (
                      "-"
                    ) : (
                      <>{item.info.customerName}</>
                    )}
                  </div>

                  <div className="bg-gray-200 r p-1 text-gray-500 text-base px-3">
                    {t("Vehicle")} {" : "}
                    {item.info.vehType == "" ? (
                      "-"
                    ) : (
                      <>
                        <ReturnVehicleType vt={item.info.vehType} />
                      </>
                    )}
                  </div>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      {/* Modal */}
      {showModal && (
        <>
          <CancelAppointmentModal
            showModal={showModal}
            setshowModal={setshowModal}
            cancelObject={selectedData}
            cancelCall={cancelCall}
          />
        </>
      )}
    </>
  );
}

export default AppointmentsTable;
